import { Link, Navigate } from 'react-router-dom'

import { Netzstreifen } from '../../components/Netzstreifen'
import { BackIcon, DiskIcon, NotizIcon, PulseIcon, SlidersIcon } from '../../components/Icons'
import { useMe } from '../../hooks/queries'
import { useTexte } from '../../texte'
import { Kategorien, type Kategorie } from './Kategorien'
import { DatenbankCard } from './DatenbankCard'
import { EnvCard } from './EnvCard'
import { EnvProtokollCard } from './EnvProtokollCard'
import { SelbstpruefungCard } from './SelbstpruefungCard'

/**
 * „Betrieb" -- die technische Seite der Installation, für den Supervisor (#62).
 *
 * Drei Kategorien: die Werte der `.env`, die Selbstprüfung (was das Hosting
 * entscheidet) und das Protokoll der Änderungen. Speicher und Dienste bleiben
 * bei der Administration, wo sie jeder Admin sieht -- nichts steht doppelt.
 *
 * **Die Weiterleitung ist Bequemlichkeit, keine Sperre**, wie bei der
 * Administration: entschieden wird im Server (`requireSupervisor`), hier
 * wird nur niemandem eine Seite gezeigt, auf der jede Anfrage 403 bekäme.
 */
export function BetriebPage() {
  const me = useMe()
  const t = useTexte()

  if (me.data !== undefined && !me.data.may_operate) {
    return <Navigate to="/settings" replace />
  }

  const kategorien: Kategorie[] = [
    {
      schluessel: 'konfiguration',
      titel: t.betrieb.konfiguration,
      symbol: <SlidersIcon size={19} />,
      inhalt: () => <EnvCard />,
    },
    {
      schluessel: 'selbstpruefung',
      titel: t.betrieb.selbstpruefung,
      symbol: <PulseIcon size={19} />,
      inhalt: () => <SelbstpruefungCard />,
    },
    {
      schluessel: 'protokoll',
      titel: t.betrieb.protokoll,
      symbol: <NotizIcon size={19} />,
      inhalt: () => <EnvProtokollCard />,
    },
    {
      schluessel: 'datenbank',
      titel: t.betrieb.datenbankTitel,
      symbol: <DiskIcon size={19} />,
      inhalt: () => <DatenbankCard />,
    },
  ]

  return (
    <>
      <Netzstreifen />
      <Kategorien
        titel={t.betrieb.titel}
        zurueck={
          <Link className="icon-button" to="/settings" aria-label={t.einstellungen.zurueck}>
            <BackIcon />
          </Link>
        }
        kategorien={kategorien}
      />
    </>
  )
}
